import React from 'react'

type ResultSectionProps = { children: React.ReactNode, title: string }
const ResultSection:React.FC<ResultSectionProps> = ({ children, title }) => (
  <div className='text-left mt-4 md:mt-6'>
    <h3 className='mb-2'>{title}</h3>
    <div className='bg-soft-green p-3 md:p-4 rounded-md'>
      {children}
    </div>
  </div>
)

const ulClassName = 'list-disc pl-4 md:pl-5'
const liClassName = 'text-gray-700 mb-2 text-xs md:text-sm'
const linkClassName = 'text-dark-green underline'

export { ulClassName, liClassName, linkClassName }
export default ResultSection
